<!--
  +---------------------------------------------------------------------------------------
  | @Copyright: Frippler Copyright (c)
  | @Title:     打印二维码
  +---------------------------------------------------------------------------------------
-->

<template>
	<div class="pp-print header-padding flex-center">
		<f-page-header />
		<div class="print-bd flex justify-content-center">
			<template v-if="step == 1">
				<vue-particles color="#07c160" :particleOpacity="0.65" :particlesNumber="70" shapeType="circle" :particleSize="5" linesColor="#07c160" :linesWidth="2" :lineLinked="true" :lineOpacity="0.4" :linesDistance="180" :moveSpeed="3" :hoverEffect="false" :clickEffect="false" class="lizi">
				</vue-particles>
				<div class="bt-area flex column align-items-center">
					<div class="font-2x mb-hg">打印工位二维码</div>

					<pp-station-selector v-model="stationid" placeholder="请选择工位" />

					<el-button class="mt-lg border" type="success" :disabled="!stationid" @click="getPrint" style="width: 100%;">
						<i class="iconfont icon-qrcode" /><span class="ml-xs">立即生成</span>
					</el-button>
				</div>
			</template>
			<template v-if="step == 2">
				<div class="flex-center column">
					<div ref="qrimg" class="qr-content flex column">
						<div class="qr-img bd">
							<div class="top">
								<div class="font-lg pt-lg">请使用微信扫一扫</div>
								<img :src="qr_code_url + '?any_string_is_ok'" class="qr-code mt-lg" crossOrigin="anonymous">
							</div>
							<div class="text-primary font-md mt-md special-text">{{station_no}} </div>
							<div class="text-primary font-2x mt-sm special-text"> {{station_title}}</div>
						</div>
						<div class="ft foot flex-center column">
							<span class="mt font-md mb-lg">{{ god }}</span>
						</div>
					</div>
					<div class="flex justify-content-space-around btns mt-lg">
						<el-button class="round-btn" type="success" @click="step = 1" plain round>重新生成</el-button>
						<el-button class="round-btn" type="success" @click="download" round>下载图片</el-button>
					</div>
				</div>
			</template>
		</div>
	</div>
</template>

<script>
import { printStationApi } from '@/api/pp/printApi'
import html2canvas from 'html2canvas';
export default {
	name: 'PpPrint',

	components: {
		PpStationSelector: () => import('@/views/pp/components/PpStationSelector'),
	},

	data () {
		return {
			step: 1,
			stationid: this.$route.query.stationid ? Number(this.$route.query.stationid) : null,
			loading: false,
			qr_code_url: '',
			station_title: '',
			station_no: '',
			god: ''
		}
	},

	computed: {
	},

	created () {
	},

	methods: {
		download () {
			html2canvas(this.$refs.qrimg, {
				scale: 5,
				backgroundColor: null,
				useCORS: true,
				allowTaint: false,
			}).then(canvas => {
				let dataURL = canvas.toDataURL("image/png");
				let aLink = document.createElement("a");
				aLink.style.display = "none";
				aLink.href = dataURL;
				aLink.download = this.station_no + ' ' + this.station_title + ".png";
				document.body.appendChild(aLink);
				aLink.click();
				document.body.removeChild(aLink);
			})
		},

		getPrint () {
			printStationApi({ stationid: this.stationid }).then(res => {
				if (!res.errno) {
					this.step = 2
					this.qr_code_url = res.data.qr_code_url
					this.station_title = res.data.station_title
					this.station_no = res.data.station_no
					this.god = res.data.god
				}
			})
		}
	}
}

</script>

<style lang="scss" scoped>
/deep/ .el-input--suffix .el-input__inner {
	border-radius: 20px;
}
.pp-print {
	position: relative;
	.print-bd {
		width: 1180px;
		height: 720px;
		margin: 20px auto 20px;
		background: #fff;
		border-radius: 5px;
		position: relative;
		z-index: 100;
		.bt-area {
			width: 280px;
			margin-top: 140px;
			z-index: 101;
			.border {
				border-radius: 20px;
			}
		}
		.lizi {
			position: absolute;
			top: 0;
			left: 0;
			right: 0;
			bottom: 0;
			z-index: 99;
		}
		.qr-content {
			position: relative;
			width: 400px;
			height: 596px;
			padding: 20px;
			box-shadow: 0px 1px 10px 0px rgba(0, 0, 0, 0.2);
			background-color: rgba(7, 193, 96, 1);

			.qr-img {
				position: relative;
				line-height: 20px;
				text-align: center;
				background: transparent;
				z-index: 1;
				// border-bottom-left-radius: 50%;
				// border-bottom-right-radius: 50%;
				overflow: hidden;
				&::before {
					content: '';
					width: 800px;
					position: absolute;
					height: 460px;
					border-bottom-left-radius: 50%;
					border-bottom-right-radius: 50%;
					top: 0;
					left: 50%;
					z-index: -1;
					background-color: #fff;
					transform: translate(-50%, 0);
					// left: -215px;
				}
				.special-text {
					text-shadow: 1px 1px 0 #cbe9ca;
				}
				.top {
					.qr-code {
						width: 260px;
						height: 260px;
					}
				}
			}
			.foot {
				color: #fff;
				// background-color: rgba(248, 249, 252, 100);
			}
		}
		.btns {
			width: 380px;
			.round-btn {
				width: 160px;
			}
		}
	}
}
</style>
